<h3>Fertigungsvorlagen</h3>

<div class="row">
  <div class="col-md-12">

    <button type="button" class="btn btn-success" (click)="templateCreate()">
      Neue Fertigungsvorlage
    </button>

  </div>
</div>

<div class="row">

  <div class="col-md-3">

    <table class="table whitetable">
      <thead>
        <tr>
          <th>Name (Bezeichnung)</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
        </tr>
      </thead>

      <tbody>
        @for (obj of templateList; track obj; let index = $index) {
          <tr [class.selectedTemplate]="obj === selected">
            <td>
              {{ obj.name }}
              @if (obj.description) {
                <span>({{ obj.description }})</span>
              }
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-link" (click)="templateEdit(index, obj)">
                <i class="fa fa-pencil"></i>
              </button>
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-link" (click)="detail(obj)">
                <i class="fa fa-chevron-right fa-1x fa-fw"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>

  </div>

  <div class="col-md-1">&nbsp;</div>

  <div class="col-md-3">
    @if (selected) {
      <h4>Fertigungsschritte in Vorlage: {{ selected.name }}</h4>
    }

    @if (selected) {
      <table class="table whitetable">
        <thead>
          <tr>
            <th>Nr.</th>
            <th>Bezeichnung</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (obj of stepList; track obj; let index = $index) {
            <tr>
              <td>{{ obj.step.nr }}</td>
              <td>{{ obj.step.text }}</td>
              <td>
                @if (!last(index)) {
                  <button type="button" class="btn btn-link btn-sm" (click)="stepUp(index, obj)">
                    <i class="fa fa-chevron-down fa-fw"></i>
                  </button>
                }
              </td>
              <td>
                @if (index !== 0) {
                  <button type="button" class="btn btn-link btn-sm" (click)="stepDown(index, obj)">
                    <i class="fa fa-chevron-up fa-fw"></i>
                  </button>
                }
              </td>
              <td>
                <button type="button" class="btn btn-sm btn-link" (click)="stepEdit(index, obj)">
                  <i class="fa fa-pencil"></i>
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-link btn-sm" (click)="stepDelete(index, obj)">
                  <i class="fa fa-trash-o fa-fw"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    }

  </div>
  <div class="col-md-1">&nbsp;</div>

  <div class="col-md-3">
    <h4>Restlichen Fertigungsschritte</h4>

    <table class="table whitetable">
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Nr.</th>
          <th>Bezeichnung</th>
        </tr>
      </thead>

      <tbody>
        @for (obj of steps; track obj; let index = $index) {
          <tr>
            <td>
              @if (selected) {
                <button type="button" class="btn btn-sm btn-link" (click)="stepAdd(obj)">
                  <i class="fa fa-chevron-left fa-1x fa-fw"></i>
                </button>
              }
            </td>
            <td>{{ obj.nr }}</td>
            <td>{{ obj.text }}</td>
          </tr>
        }
      </tbody>
    </table>

  </div>
  <div class="col-md-1">&nbsp;</div>

</div>
